// extracted by mini-css-extract-plugin
export default {"container":"_500_container__0BQC7"};